import {
  TAdvancedAccessLevels,
  TGranularPermission,
  TSemiGranularPermission,
  TUpdateShareDTO,
} from 'src/app/project/modules/share/share.model';

export const createPartialShareDTOForComments = (
  granularPermission: TGranularPermission,
): TUpdateShareDTO =>
  createPartialShareDTOWrapper({
    timeline: {
      comments: createPermissionWrapper(granularPermission),
    },
  });

const createPartialShareDTOWrapper = (
  advancedAccessLevel: Partial<TAdvancedAccessLevels>,
): { advancedAccessLevels: Partial<TAdvancedAccessLevels> } => ({
  advancedAccessLevels: advancedAccessLevel,
});

const createPermissionWrapper = (
  granularPermission: TGranularPermission,
): { permission: TGranularPermission } => ({
  permission: granularPermission,
});

export const createPartialShareDTOForTags = (
  granularPermission: TGranularPermission,
): TUpdateShareDTO =>
  createPartialShareDTOWrapper({
    tags: createPermissionWrapper(granularPermission),
  });

export const createPartialShareDTOForFlags = (
  granularPermission: TGranularPermission,
): TUpdateShareDTO =>
  createPartialShareDTOWrapper({
    flags: createPermissionWrapper(granularPermission),
  });

export const createPartialShareDTOForCF = (
  granularPermission: TGranularPermission,
  customFieldId: string,
): TUpdateShareDTO => {
  if (!customFieldId) {
    return {};
  }

  return createPartialShareDTOWrapper({
    customFields: [
      {
        templateId: customFieldId,
        ...createPermissionWrapper(granularPermission),
      },
    ],
  });
};

export const createPartialShareDTOForActivities = (
  semiGranularPermission: TSemiGranularPermission,
): TUpdateShareDTO =>
  createPartialShareDTOWrapper({
    timeline: createSemiPermissionWrapper(semiGranularPermission),
  });

const createSemiPermissionWrapper = (
  semiGranularPermission: TSemiGranularPermission,
): { permission: TSemiGranularPermission } => ({
  permission: semiGranularPermission,
});

export const createPartialShareDTOForExports = (
  semiGranularPermission: TSemiGranularPermission,
): TUpdateShareDTO =>
  createPartialShareDTOWrapper({
    exports: createSemiPermissionWrapper(semiGranularPermission),
  });

export const createPartialShareDTOForRelatedPoints = (
  granularPermission: TGranularPermission,
): TUpdateShareDTO =>
  createPartialShareDTOWrapper({
    pointsRelationships: createPermissionWrapper(granularPermission),
  });
